import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const VLANProfileSettingsHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-settings-help", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="VLAN Profile settings"
      onClose={doClose}
      content={() => (
        <React.Fragment>
          <p>
            VLAN Profiles. Match traffic of the specified list of VLAN tags.
          </p>
          <ul>
            <li>
              <b>NAME</b>: Profile name.
            </li>
            <li>
              <b>VLAN</b>: VLAN tag, <i>none</i> for no tag.
            </li>
          </ul>
          <p>
            Click on the <i className="material-icons valign-icon">edit</i> icon
            to edit an already configured profile entry.
          </p>
          <p>
            Click on the <i className="material-icons valign-icon">delete</i>{" "}
            icon to delete a single profile entry.
          </p>
          <p>
            Press the <i className="material-icons valign-icon">more_vert</i>{" "}
            icon and then select the <b>Add VLAN Tag...</b> option to add a new
            VLAN tag to the profile.
          </p>
        </React.Fragment>
      )}
    />
  );
};

export default VLANProfileSettingsHelpModal;
